import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bulk-actions"
export default class extends Controller {
  static targets = ["count", "checkbox"]

  connect() {
    this.updateCount()
  }

  toggleAll(event) {
    const isChecked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateCount()
  }

  updateCount() {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked)
    this.countTarget.textContent = checkedBoxes.length
    
    // Update the form to include selected user IDs
    this.updateSelectedUsers(checkedBoxes)
  }

  updateSelectedUsers(checkedBoxes) {
    // Remove any existing hidden inputs for user_ids
    const existingInputs = this.element.querySelectorAll('input[name="user_ids[]"][type="hidden"]')
    existingInputs.forEach(input => input.remove())

    // Add hidden inputs for selected users
    const form = this.element.querySelector('form')
    if (form) {
      checkedBoxes.forEach(checkbox => {
        const hiddenInput = document.createElement('input')
        hiddenInput.type = 'hidden'
        hiddenInput.name = 'user_ids[]'
        hiddenInput.value = checkbox.value
        form.appendChild(hiddenInput)
      })
    }
  }

  submit(event) {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked)
    
    if (checkedBoxes.length === 0) {
      event.preventDefault()
      alert('Please select at least one user before applying bulk actions.')
      return false
    }

    // Double-check that we have the selected users in the form
    this.updateSelectedUsers(checkedBoxes)
    return true
  }
}